<template>
  <div :class="$style.wrapper">
    <p :class="$style.title">評価の依頼</p>
    <p :class="$style.text">
      {{
        userNickname
      }}さんに評価依頼を送信します。一度送信すると取り消しはできません。
    </p>
    <section :class="$style.buttonSection">
      <FlatButton variant="secondary" @click="$emit('cancel')">
        キャンセル
      </FlatButton>
      <FlatButton @click="$emit('confirm')">送信</FlatButton>
    </section>
  </div>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'

defineProps<{
  userNickname: string
}>()

defineEmits<{
  (event: 'confirm'): void
  (event: 'cancel'): void
}>()
</script>

<style lang="scss" module>
.wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}

.title {
  font-size: 20px;
  font-weight: bold;
}

.buttonSection {
  display: flex;
  justify-content: center;
  gap: 16px;
}
</style>
